import {
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import * as React from "react";
import API from "../../Api/api";
import toast from "react-hot-toast";
import NumberToWords from "number-to-words";
import Logo from "../../assets/Logo.png";
import { Helmet } from "react-helmet-async";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
function numberToWords(number) {
  const units = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
  ];
  const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  if (number === 0) {
    return "zero";
  }

  function convert(number) {
    let words = "";

    if (number >= 1000000000) {
      words += convert(Math.floor(number / 1000000000)) + " billion, ";
      number %= 1000000000;
    }

    if (number >= 1000000) {
      words += convert(Math.floor(number / 1000000)) + " million, ";
      number %= 1000000;
    }

    if (number >= 1000) {
      words += convert(Math.floor(number / 1000)) + " thousand, ";
      number %= 1000;
    }

    if (number >= 100) {
      words += convert(Math.floor(number / 100)) + " hundred ";
      number %= 100;
    }

    if (number > 0) {
      if (words !== "") {
        words += "and ";
      }

      if (number < 10) {
        words += units[number] + " ";
      } else if (number < 20) {
        words += teens[number - 10] + " ";
        number = 0; // Skip further processing for teens
      } else {
        words += tens[Math.floor(number / 10)] + " ";
        number %= 10;
        if (number > 0) {
          words += units[number] + " ";
          number = 0; // Skip further processing for units
        }
      }
    }

    return words.trim();
  }

  const words = convert(number);
  return words;
}
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});
export default function ClaimDetail() {
  const [payMessage, setPayMessage] = React.useState(false);

  const [code, setCode] = React.useState("");
  const [data, setData] = React.useState([]);
  const searchData = async () => {
    let fetchingId;
    try {
      if (!code) {
        toast.error("Please enter claim code");
        return;
      }
      fetchingId = toast.loading("Fetching claim data...");
      const res = await API.get(
        `/api/v1/eClaim?status[eq]=approved&claim_code[eq]=${code}`
      );
      if (res.data.length >= 1) {
        setData(res.data);
        setPayMessage(true);
      }
      if (res.data.length === 0) {
        toast.remove(fetchingId);
        toast.error("No data found for this code");
        return;
      }
      toast.remove(fetchingId);
      toast.success("Data successfully retrieved...");
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handlePrint = (rowData) => {
    const amountFirst = Math.floor(rowData.amount);
    const amountInWords = numberToWords(amountFirst);
    const decimalValue = (rowData.amount % 1).toFixed(2).split(".")[1];

    // Create a new window for printing
    const printWindow = window.open("", "_blank");

    // Create the HTML content to be printed
    const content = `
      <html>
        <head>
          <title>Claim Form</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 18px;
              margin: 0;
              padding: 0;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              box-sizing: border-box;
            }
            .content {
              width: 100%;
              max-width: 800px;
              padding: 20px;
              box-sizing: border-box;
              position: relative;
              text-align: center;
            }
            .watermark {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0.1;
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              z-index: -1;
            }
            .watermark span {
              font-size: 40px;
              font-weight: bold;
              color: #000;
              margin: 30px;
              transform: rotate(-30deg);
              white-space: nowrap;
              opacity: 0.5;
            }
            .amount {
              font-weight: bold;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #ccc;
            }
            .company {
              width: 100%;
              margin-bottom: 20px;
            }
              .company_name{
              text-decoration: underline;
              }
            .claim-code {
              margin-top: 20px;
              padding: 10px;
              background-color: #f1f1f1;
              font-weight: bold;
              border-radius: 25px;
             border: 1px solid #52525b !important;
            }
               @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              th {
                background-color: #ccc !important;
              }
              .claim-code {
                background-color: #f1f1f1 !important;
                border-radius: 25px;
                border: 1px solid #52525b !important;
              }
            }
           .watermark_company.top-left {
            top: 20px;
            left: 20px;
          }
          
          .watermark_company.bottom-right {
            bottom: 20px;
            right: 20px;
          }
          .watermark_company {
            position: absolute;
            top: 50%;
            left: 50%;
            opacity:0.3;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.2);
            pointer-events: none;
            z-index: -1;
          }
          .am
          </style>
        </head>
        <body>
          <div class="watermark">
            <span>Bosome Freho Rural Bank PLC</span>
            <span>Bosome Freho Rural Bank PLC</span>
            <span>Bosome Freho Rural Bank PLC</span>
            <span>Bosome Freho Rural Bank PLC</span>
            <span>Bosome Freho Rural Bank PLC</span>
            <span>Bosome Freho Rural Bank PLC</span>
          </div>
          <div class="content">
            <h1 class='company_name'>Bosome Freho Rural Bank PLC Claim Form</h1>
            <img class='watermark_company' id="logoImage" src=${Logo} alt='logo'/>
            <p class='company'><span class='amount'>Company name:</span> Bosome Freho Rural Bank PLC </p>
            <p class='company'><span class='amount'>Employee name:</span> ${
              rowData.employee_name
            } </p>
            <p class='company'><span class='amount'>Department:</span> ${
              rowData.department
            }</p>
            <table>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Category</th>
                <th>Amount Paid</th>
              </tr>
              <tr>
                <td>${rowData.date}</td>
                <td>${rowData.description}</td>
                <td>${rowData.category}</td>
                <td>${currencyFormatter.format(rowData.amount)}</td>
              </tr>
              <tr>
                <td colspan='4'><span class='amount'>Amount in words:</span> <em>${amountInWords} Ghana cedis${
      decimalValue > 0 ? "," : ""
    } ${
      decimalValue >= 1
        ? ` ${NumberToWords.toWords(decimalValue)} Ghana pesewa${
            decimalValue > 1 ? "s" : ""
          }`
        : "only"
    }</em></td>
              </tr>
            </table>
            <p class='amount company'>Employee/recipient signature: ........................................</p>
            <p class='amount company'>Sanctioned By: ${
              rowData.sanctioned_by
            }.  <span class="sanctioned_by">Signature: ...................................</span></p>
            <p class='amount company'>Status: ${rowData.status}</p>
            <p class='amount company'>Payment Status: ${
              rowData.payment_status
            }</p>
            <p class='amount company'>Approved by: ${rowData.approved_by}</p>
            <p class='amount company'>Position: ${
              rowData.approvers_position
            }</p>
            <p class='claim-code'><span class='amount'>Claim code:</span> ${
              rowData.claim_code
            }</p>
          </div>
        </body>
      </html>
    `;

    // Write the HTML content to the new window
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();

    // Wait for the window to fully load before printing
    Promise.all([
      new Promise((resolve, reject) => {
        const logoImage = printWindow.document.getElementById("logoImage");
        logoImage.onload = resolve;
        logoImage.onerror = reject;
      }),
    ]).then(() => {
      // Print the window once both images have loaded
      printWindow.print();
    });
  };
  return (
    <div>
      <Helmet title='claim info - eClaim' />
      <Container style={{ marginTop: "100px" }}>
        <TextField
          value={code}
          required
          onChange={(e) => setCode(e.target.value)}
          size='small'
          type='text'
          label='claim code'
          placeholder='enter claim code'
        />
        <Button
          onClick={searchData}
          style={{
            marginLeft: "5px",
            textTransform: "none",
            backgroundColor: "#3D4F58",
          }}
          variant='contained'>
          Submit
        </Button>
        <Button
          onClick={() => {
            setPayMessage(false);
            setCode("");
            setData([]);
          }}
          style={{
            marginLeft: "5px",
            textTransform: "none",
            backgroundColor: "#dc2626",
          }}
          variant='contained'>
          Cancel
        </Button>

        <Divider
          style={{
            marginTop: "10px",
            backgroundColor: "#000",
            marginBottom: "10px",
          }}
        />
        {payMessage && (
          <Paper
            elevation={16}
            style={{
              backgroundColor: "#D7DED0",
              padding: "5px",
            }}>
            <Box>
              <Typography>
                <strong>Employee/recipient name:</strong>
                {data[0].employee_name}
              </Typography>
              <Typography>
                <strong>Department</strong>: {data[0].department}
              </Typography>
              <Typography>
                <strong>Category:</strong>

                {data[0].category}
              </Typography>
              <Typography>
                <strong>Date:</strong>
                {moment(data[0].date).format("DD-MM-YYYY")}
              </Typography>
              <Typography>
                <strong>Description:</strong>

                {data[0].description}
              </Typography>
              <Typography>
                <strong>Amount:</strong>

                {data[0].amount}
              </Typography>
              <Typography>
                <strong>Status:</strong>

                {data[0].status}
              </Typography>
              <Typography>
                <strong>Payment Status:</strong>

                {data[0].payment_status}
              </Typography>
              <Typography>
                <strong>Sanctioned By:</strong>

                {data[0].sanctioned_by}
              </Typography>
              <Typography>
                <strong>Approved By:</strong>

                {data[0].approved_by}
              </Typography>
              <Typography style={{ marginTop: "10px" }}>
                Claim code:
                {data[0].claim_code}
              </Typography>
              <Divider />
            </Box>
            <Tooltip title='Print'>
              <IconButton onClick={() => handlePrint(data[0])}>
                <PrintRoundedIcon />
              </IconButton>
            </Tooltip>
          </Paper>
        )}
      </Container>
    </div>
  );
}
